
import React, { useEffect, useState, useRef } from "react";
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from '@mui/material/Autocomplete';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import axios, { AxiosError, AxiosResponse } from "axios";

import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import moment from 'moment'
import { Formik } from 'formik';
import * as Yup from 'yup';
import FormGroup from '@mui/material/FormGroup';
import { editPasswordByUserLogin } from '../hook/useUserApi'
import { useNavigate, useHistory, useLocation } from "react-router-dom";
import LoadingPage from '../../../components/Loading'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { getProfile } from '../../Auth/hook/useLogin'
import { passwordExpireHandler, authTokenHandler } from '../../../util/local-storage';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ChangePasswordByUserForm: React.FC = (props) => {
    const [notifyMessage, setNotifyMessage] = useState("");
    const [loadingPageFlag, setLoadingPageFlag] = useState(1);
    const [typeNotify, setTypeNotify] = useState('');
    const [openNotify, setNotify] = useState(false);
    const navigate = useNavigate();
    const [stateUserUpdate, setStateUserUpdate] = useState({
        oldPassword: null,
        password: null,
        confirmPassword: null
    });

    const handleCloseDialog = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotify(false);
    };

    const handleNotify = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setNotify(true);
    };
    const [userName, setUserName] = useState({})


    const updateUserInfo = async (value) => {
        //debugger;
        setLoadingPageFlag(1);
        var results = await editPasswordByUserLogin(value);
        var { code, content, data, description, message } = results.data;

        if (code === 200) {


            setNotifyMessage('Password changed successfully. Please log in again.');
            setTypeNotify('success');
            handleNotify();

            var token = authTokenHandler.get();
            getProfile(token).then((pResult) => {
                const { status, data: dataProfile } = pResult;
                if (status == 200) {
                    passwordExpireHandler.set(dataProfile.password_Expired);
                } else {
                    navigate("../login");
                }
            });

            setTimeout(function () { //Start the timer

                //After 1 second, set render to true
                props.editPasswordHandler(results);
            }.bind(this), 1000)

        } else {
            setNotifyMessage(content ?? description);
            setTypeNotify('error')
            //setTypeNotify('Password change unsuccessful Please try again later!');
            handleNotify();

        }
        setLoadingPageFlag(2);


    }


    useEffect(() => {

        var locationPath = window.location;
        const strUserName = localStorage.getItem("userName");

        if (strUserName != null && strUserName != undefined && strUserName != "") {

            setUserName(strUserName);
            setLoadingPageFlag(0)
        } else {

            // 
            if (locationPath.pathname === "/laundryyouupdate") {

            } else {


            }


        }




    }, [userName])


    return (
        <div  >
            <LoadingPage flag={loadingPageFlag} />
            <Dialog
                open={props.isDisplay}
                onClose={props.handleClose}
                fullWidth="xs"
                maxWidth="xs"

            >
                <Formik
                    initialValues={stateUserUpdate}
                    validationSchema={Yup.object().shape({
                        oldPassword: Yup.string()
                            .required('Old Password is required.'),
                        password: Yup
                            .string()
                            .required('Password is required')
                            //.min(8, 'Your password is too short.')
                            .matches(
                                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
                                "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
                            ),
                        confirmPassword: Yup
                            .string()
                            .oneOf([Yup.ref('password')], 'Passwords must match')





                    })}


                    onSubmit={(values, { setSubmitting }) => {
                        //editPasswordByUserLogin
                        //debugger;
                        updateUserInfo(values);

                        //props.editPasswordHandler(values, props.mode);

                    }}



                >
                    {(formik) => (
                        <form onSubmit={formik.handleSubmit}   >
                            <div>
                                <DialogTitle>Change Password </DialogTitle>
                                <IconButton
                                    aria-label="close"
                                    onClick={props.handleClose}
                                    sx={(theme) => ({
                                        position: 'absolute',
                                        right: 8,
                                        top: 8,
                                        color: theme.palette.grey[500],
                                    })}
                                >
                                    <CloseIcon />
                                </IconButton>
                                <DialogContent className="border-2">
                                    <div>


                                        <div className="clear mt-10"></div>
                                        <div className='grid  grid-cols-1 gap-6    '>



                                            <div className='mr-2 input-group'>

                                                <TextField
                                                    size="small"
                                                    label="Username"
                                                    fullWidth

                                                    disabled={true}
                                                    value={userName}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}

                                                />

                                            </div>


                                            <div className='mr-2 input-group'>

                                                <TextField
                                                    size="small"
                                                    label="Old Password"
                                                    fullWidth
                                                    id="oldPassword"
                                                    type="password"
                                                    name="oldPassword"

                                                    value={formik.values.oldPassword}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.oldPassword && Boolean(formik.errors.oldPassword)}
                                                    helperText={formik.touched.oldPassword && formik.errors.oldPassword}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}

                                                />

                                            </div>
                                            <div className='mr-2 input-group'>

                                                <TextField
                                                    size="small"
                                                    label="New Password"
                                                    type="password"
                                                    fullWidth
                                                    id="password"
                                                    name="password"
                                                    value={formik.values.password}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.password && Boolean(formik.errors.password)}
                                                    helperText={formik.touched.password && formik.errors.password}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}

                                                />

                                            </div>
                                            <div className='mr-2 input-group'>

                                                <TextField
                                                    size="small"
                                                    label="Confirm Password"
                                                    type="password"
                                                    fullWidth
                                                    id="confirmPassword"
                                                    name="confirmPassword"
                                                    value={formik.values.confirmPassword}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                                                    helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}

                                                />

                                            </div>













                                        </div>
                                        <div className="clear mt-b0"></div>



                                        {/*</form>

                            )}

                        </Formik>*/}
                                    </div>

                                </DialogContent>
                                <DialogActions>

                                    <Button variant="contained" type="submit" color="primary"  >Save</Button>

                                    <Button variant="contained" color="error" onClick={props.handleClose}>Cancel</Button>
                                </DialogActions>
                            </div>
                        </form>
                    )}

                </Formik>

            </Dialog>

            <Snackbar open={openNotify} autoHideDuration={6000} onClose={handleCloseDialog} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                key={"top" + "center"}>
                <Alert onClose={handleCloseDialog} severity={typeNotify} sx={{ width: '100%' }}>
                    {notifyMessage}
                </Alert>
            </Snackbar>


        </div >
    );
};

ChangePasswordByUserForm.propTypes = {
    //type: PropTypes.oneOf(['task-service', 'task-refund', 'task-no-tech']).isRequired,
};

ChangePasswordByUserForm.defaultProps = {
    excludeTaskStatus: [],
    showRefundStatus: false,
    isTechnician: false,
    onSearch: () => { },
    onSubmit: () => { },
    onReset: () => { },

};

export default ChangePasswordByUserForm;
